import { render, staticRenderFns } from "./MallDialog.vue?vue&type=template&id=0b50f111&"
import script from "./MallDialog.vue?vue&type=script&lang=js&"
export * from "./MallDialog.vue?vue&type=script&lang=js&"
import style0 from "./MallDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports